import AxiosConfig from '../../../config/AxiosConfig';
import { useDispatch } from 'react-redux';
import { setSnackBar } from '../../states/app/staticSlice';

function useTemplateUpdate() {
  const dispatch = useDispatch();
  const updateTemplate = async (formData) => {
    try {
      const response = await AxiosConfig.create('post', `/templates/update`)
        .call(formData)
        .getResponseData();
      if (response?.status > 300) {
        const messageError = `Error ${response?.status} - ${response?.message} in useTemplateUpdate`;
        dispatch(
          setSnackBar({ open: true, message: messageError, color: 'error' })
        );
      }
      return response;
    } catch (err) {
      console.error('Failed to delete template:', err);
      throw new Error(`Delete template failed: ${err.message}`);
    }
  };

  return {
    updateTemplate,
  };
}

export default useTemplateUpdate;
